import React, { useCallback } from 'react';
import type { PackageDetails } from '../../services/Clients/S3Client';

interface IProps {
    readonly branches: PackageDetails[];
    readonly selected: PackageDetails | null;
    readonly onChange: (branchFolder: string) => void;
}

const BranchOptions: React.FC<IProps> = ({ branches, selected, onChange }) => {
    const renderOption = useCallback((branch: PackageDetails) => {
        const isActive = selected?.folder === branch.folder;
        const check = isActive ? " ✓" : null;
        return (
            <button
                type="button"
                className={`scolab-switcher-s3dialogselector-choice ${isActive ? 'active' : ''}`}
                key={branch.folder}
                value={branch.folder}
                onClick={() => onChange(branch.folder)}
            >
                <strong>{branch.label}{check}</strong>
                <time>{branch.dateLabel}</time>
            </button>
        );
    }, [selected, onChange]);

    return (
        <div className="scolab-switcher-s3dialogselector-popup scolab-switcher-s3dialogselector-popup-branches">
            {branches.map(renderOption)}
        </div>
    );
};

export default BranchOptions;
